import { injectReducer } from '../../store/reducers'

export default (store) => ({
  path : '/summary',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const Summary = require('./containers/SummaryContainer').default
      const reducer = require('../../store/product').default

      /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, { key: 'product', reducer })

      /*  Return getComponent   */
      cb(null, { category:null, main:Summary })

    /* Webpack named bundle   */
    }, 'summary')
  }
})



// WEBPACK FOOTER //
// ./src/routes/Summary/index.js